import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { ClientInput } from '@/lib/api/domains/clients';
import { keys } from '@/lib/query-keys';

export function useCreateClient() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ClientInput) => api.clients.create(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.clients.lists() });
    },
  });
}
